import styles from './style.module.scss';
import { Button } from '../button/button';
import { Copy } from '../copy/copy';
import { IconWithLabel } from '../iconWithLabel/iconWithLabel';

interface IProps {
	options: string[];
	setActiveOption: (filterName: string, filterValue?: string, isFilter?: boolean) => void;
	filterCategoryName: string;
	setIsOpen: (index: number) => void;
	currentIndex: number;
	placeHolder: string;
	currentOption?: string;
	isOpen?: boolean;
	className?: string;
}

export function DropDown({
	options,
	setActiveOption,
	filterCategoryName,
	isOpen,
	setIsOpen,
	currentIndex,
	currentOption,
	className,
	placeHolder,
}: IProps) {
	const { labels } = window;
	const setDropdownSelection = (filterValue?) => {
		setActiveOption(filterCategoryName, filterValue, true);
		setIsOpen(-1);
	};

	return (
		<div className={`${styles.selectWrapper} ${className}`}>
			<Button
				onClick={() => setIsOpen(isOpen ? -1 : currentIndex)}
				isSecondary
				fullwidth
				className={`${styles.dropdown} ${isOpen ? styles.active : ''}`}
			>
				<IconWithLabel tag="div" className={styles.triangle}>
					<Copy className={styles.placeholder} text={placeHolder} />
					<Copy text={currentOption ? currentOption : labels['filter.default']} />
				</IconWithLabel>
			</Button>
			{isOpen && (
				<ul className={styles.dropdownMenu}>
					<li className={styles.dropdownMenuItem} onClick={() => setDropdownSelection(undefined)}>
						Alle
					</li>
					{options &&
						options.map((option) => (
							<li
								key={option}
								className={styles.dropdownMenuItem}
								onClick={() => setDropdownSelection(option)}
							>
								<Copy text={option} />
							</li>
						))}
				</ul>
			)}
		</div>
	);
}
